module.exports = __webpack_public_path__ + "img/d9.48a0c7b2.png";